import { useState } from 'react';
import { useSearchParams } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api } from '../../api/context';
import toast from '../../utils/toast';
import Base from '../Base';
import styles from './Forgot.module.scss';

const Forgot = () => {

  const [ loading, setLoading ] = useState(false);
  const [ params, setParams ] = useSearchParams();

  const email = params.get('value');

  const next = (email) => {

    const params = new URLSearchParams();

    params.append('dialog', 'forgot-confirm');
    params.append('email', email);

    setParams(params);
  };

  return (
    <Base title='Forgot Password'>
      <div className={styles.root}>

        <Formik
          initialValues={{
            email,
          }}
          validationSchema={yup.object({
            email: yup.string()
              .email('Invalid email address')
              .required('Email required'),
          })}
          onSubmit={(values, actions) => {

            if (loading) {
              return;
            }

            setLoading(true);

            api().v1.auth.forgot.post(values)
              .then(res => {
                setLoading(false);

                if (res.status === 200) {
                  actions.resetForm();
                  next(values.email);
                }

                if (res.status === 400) {
                  toast.show(toast.KIND.ERROR, res.body);
                }
              })
              .catch(err => {
                setLoading(false);
                toast.show(toast.KIND.WARNING, err);
              });

          }} >

          <Form>
            <div>
              <Field
                aria-label='email'
                placeholder='Email'
                name='email'
                type='email'
                disabled={loading}
              />
              <ErrorMessage
                name='email'
                component='div'
              />
            </div>

            <button
              aria-label='request code'
              type='submit'
              disabled={loading}>

              Request Code

            </button>
          </Form>

        </Formik>
      </div>
    </Base>
  );
};

export default Forgot;